/**
 * Pins: a place's name and coordinates beside its mark on the globe. The mark
 * itself is drawn by the globe; this is the label, placed over the canvas.
 * The coordinate string is read from the page (data-coords on each stop section),
 * so one script bundle serves every locale with no hardcoded strings.
 */
import type { Viewport } from '../viewport'
import type { Stop } from './stops'

/* =====================================================================
   TUNING
   ===================================================================== */
const LABELS = 1.0 /* the place's name and coordinates beside its pin (0 = off) */
/* ===================================================================== */

export function createPins(container: HTMLElement, places: Stop[]) {
  const pins = places.map((place) => {
    const pin = document.createElement('div')
    pin.className = 'pin'
    pin.innerHTML = `${place.place}<small>${place.coords}</small>`
    container.appendChild(pin)
    place.pin = pin
    return pin
  })

  return {
    /** Puts every label beside its place, as visible as the place is. */
    place(vp: Viewport) {
      places.forEach((p, i) => {
        const el = pins[i]
        const a = p.act * p.vis * LABELS
        if (a < 0.01) {
          el.style.opacity = '0'
          return
        }
        const off = vp.min * 0.028
        el.style.transform = `translate(${(p.px + off).toFixed(1)}px,${(p.py - off * 0.9).toFixed(1)}px)`
        el.style.opacity = a.toFixed(3)
      })
    },
    hideAll() {
      for (const el of pins) el.style.opacity = '0'
    },
  }
}

export type Pins = ReturnType<typeof createPins>
